import React from 'react';
import clsx from 'classnames';
import './index.css';
import QueueAnim from 'rc-queue-anim';
import Core from '../Core';

const Introduction = () => {
  const typeList = [
    { desc: '制造/研发', path: '/img/make.png' },
    { desc: '实验室建设', path: '/img/laboratory.png' },
    { desc: '检测/校准', path: '/img/detection.png' },
    { desc: '增值服务', path: '/img/increment.png' },
  ];

  return (
    <QueueAnim className={clsx('blurb-content')} type={['bottom', 'top']}>
      <div className={clsx('blurb-content__title')} key='blurb-content__title'>
        公司简介
      </div>
      <div className={clsx('blurb-content__info')} key='blurb-content__info'>
        <QueueAnim
          className={clsx('blurb-content__img')}
          type={['left', 'right']}
        >
          <img src='/img/company.png' alt='' key='blurb-content__img' />
        </QueueAnim>
        <QueueAnim
          className={clsx('blurb-content__text')}
          type={['right', 'left']}
        >
          <div
            className={clsx('blurb-content__desc')}
            key='blurb-content__desc'
          >
            公司成立于2018年1月，注册资金1050万，位于杭州余杭区瓶窑南佳科技园，是一家国家高新技术企业和浙江省“专精特新”企业。公司拥有成熟的研发和生产制造团队，骨干成员均在国家电网、国有研究院所和国家产品质检中心等从业近二十年，熟悉电力器材、电缆、电力金具、输电杆塔、紧固件、安全工器具、机具、带电作业工器具、高处作业防坠落器材等产品的检测技术和仪器设备，拥有数十项专利和软件著作权。通过了ISO三体系认证，研发生产的检验检测用仪器设备销售覆盖全国32个省市自治区，近300家企事业单位的实验室。公司是能源行业电力安全工器具及机具标委会委员单位，目前已主编和参与编制数十份国际、行业和团体标准。
          </div>
          <QueueAnim
            className={clsx('blurb-content__type')}
            type={['bottom', 'top']}
            key='blurb-content__type'
          >
            {typeList?.map((v, index) => {
              return (
                <div className={clsx('blurb-content__type-item')} key={index}>
                  <div className={clsx('blurb-content__type-img')}>
                    <img src={v.path} alt='' width={39} height={38} />
                  </div>
                  <div className={clsx('blurb-content__type-desc')}>
                    {v.desc}
                  </div>
                </div>
              );
            })}
          </QueueAnim>
        </QueueAnim>
      </div>
      {/* 核心技术 */}
      <div key='core'>
        <Core />
      </div>
    </QueueAnim>
  );
};

export default Introduction;
